
/**
 * Ticket: SL-660
 * JIRA: https://toolsvilla.atlassian.net/browse/SL-660
 * Description: Need Success popup to show the message
 * Author: Ankit Nigam
 * Date: 17 Jan 2025
 */
import React from "react";
import "./SuccessPopup.css"; // CSS for styling the popup

const SuccessPopup = ({ product, onClose,msg,titleMsg  }) => {
    
    return (
        <div className="success-popup-overlay">
          <div className="success-popup-container">
            <button className="success-popup-close-button" onClick={onClose}>
              &times;
            </button>
            <div className="success-popup-content">
              <div className="success-popup-header">
                <img
                 src={"https://s3.toolsvilla.com/" + product?.images?.[0]?.image}

                 alt={product.name}
                 className="success-popup-product-image"
                />
                <div className="success-popup-product-details">
                  <h2 className="success-popup-product-name">{product.name}</h2>
                  <span className="success-popup-sku">SKU: {product.SKU}</span>
                </div>
              </div>
              <div className="success-popup-status-message">
                <img className="success-popup-check-icon" src="/verify-circle.png"/>
                <h3>{titleMsg ? titleMsg : "Your Request has been Accepted"}</h3>
              </div>
              <p>
                {
                    msg ? msg:<>Please be patient while we review your price offer and assign this
                order to you.</>
                }
                

              </p>
            </div>
          </div>
        </div>
   );

 
};


export default SuccessPopup;

